import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  makeStyles,
  Menu,
  Paper,
  Theme,
  Typography,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import CloseIcon from "@material-ui/icons/Close";
import DescriptionIcon from "@material-ui/icons/Description";
import PublishIcon from "@material-ui/icons/Publish";
import SaveIcon from "@material-ui/icons/Save";
import VideocamIcon from "@material-ui/icons/Videocam";
import managerFilesApi from "api/managerFiles";
import { useAppDispatch, useAppSelector } from "app/hooks";
import EMOJI from "assets/img/emoji.png";
import ICON_VIDEO from "assets/img/icon_video.png";
import axios, { AxiosResponse } from "axios";
import CheckboxField from "components/FormFields/CheckboxField";
import InputField from "components/FormFields/InputField";
import { SelectField } from "components/FormFields/SelectFiled";
import { BASE_URL, TOKEN } from "constants/config";
import Picker, { SKIN_TONE_MEDIUM_DARK } from "emoji-picker-react";
import {
  fetchCategoryList,
  selectCategoryList,
} from "features/Admin/pages/ManagerCategory/managerCategorySlice";
import { CreateLesson } from "models/managerLesson";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: "0 24px 48px 24px",
    maxWidth: 1200,
    margin: "0 auto",
    boxSizing: "border-box",
    [theme.breakpoints?.down("md")]: {
      padding: "0 12px 24px 12px",
    },
  },
  headerBanner: {
    background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #312E81 100%)",
    borderRadius: 24,
    padding: "24px 32px",
    color: "#FFFFFF",
    marginBottom: 24,
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 12px 32px rgba(15, 23, 42, 0.15)",
    display: "flex",
    alignItems: "center",
    gap: 16,
    [theme.breakpoints?.down("md")]: {
      padding: "16px 20px",
      borderRadius: 16,
      marginBottom: 16,
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: "-40%",
      right: "-10%",
      width: 300,
      height: 300,
      background:
        "radial-gradient(circle, rgba(99, 102, 241, 0.25) 0%, rgba(99, 102, 241, 0) 70%)",
      pointerEvents: "none",
    },
  },
  btnBack: {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(8px)",
    color: "#FFFFFF",
    borderRadius: 12,
    padding: "8px 16px",
    fontWeight: 700,
    fontSize: "0.875rem",
    textTransform: "none",
    transition: "all 0.2s ease",
    zIndex: 2,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.25)",
      transform: "translateX(-2px)",
    },
  },
  bannerTitle: {
    color: "#FFFFFF",
    fontSize: "1.5rem",
    fontWeight: 800,
    zIndex: 2,
    [theme.breakpoints?.down("md")]: {
      fontSize: "1.125rem",
    },
  },
  sectionCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 20,
    padding: 28,
    marginBottom: 24,
    border: "1px solid #E2E8F0",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.03)",
    [theme.breakpoints?.down("sm")]: {
      padding: 18,
      borderRadius: 16,
      marginBottom: 16,
    },
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 20,
    paddingBottom: 12,
    borderBottom: "1px solid #F1F5F9",
  },
  sectionTitle: {
    fontWeight: 800,
    fontSize: "1.0625rem",
    color: "#0F172A",
  },
  fieldLabel: {
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#334155",
    marginBottom: 6,
    display: "block",
  },
  dropzoneWrapper: {
    border: "2px dashed #CBD5E1",
    borderRadius: 16,
    backgroundColor: "#F8FAFC",
    padding: 32,
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#EEF2FF",
      borderColor: "#818CF8",
    },
  },
  dropzoneContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
  },
  dropzoneIcon: {
    width: 64,
    height: 64,
    marginBottom: 8,
  },
  dropzoneText: {
    fontSize: "0.9375rem",
    fontWeight: 700,
    color: "#1E293B",
  },
  dropzoneSubtext: {
    fontSize: "0.8125rem",
    color: "#64748B",
  },
  videoPreviewWrapper: {
    position: "relative",
    borderRadius: 16,
    overflow: "hidden",
    backgroundColor: "#0F172A",
    maxHeight: 450,
  },
  closePreviewBtn: {
    position: "absolute",
    top: 12,
    right: 12,
    zIndex: 10,
    backgroundColor: "rgba(15, 23, 42, 0.7)",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "rgba(15, 23, 42, 0.9)",
    },
  },
  actionBar: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 12,
    marginTop: 32,
  },
  btnDraft: {
    backgroundColor: "#F1F5F9",
    color: "#334155",
    borderRadius: 12,
    padding: "10px 24px",
    fontWeight: 700,
    textTransform: "none",
    fontSize: "0.9375rem",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#E2E8F0",
      color: "#0F172A",
    },
  },
  btnCreate: {
    background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
    color: "#FFFFFF",
    borderRadius: 12,
    padding: "10px 28px",
    fontWeight: 700,
    textTransform: "none",
    fontSize: "0.9375rem",
    boxShadow: "0 4px 14px rgba(15, 23, 42, 0.25)",
    transition: "all 0.2s ease",
    "&:hover": {
      background: "linear-gradient(135deg, #1E293B 0%, #334155 100%)",
      transform: "translateY(-1px)",
    },
  },
  loadingOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(15, 23, 42, 0.6)",
    backdropFilter: "blur(4px)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#FFFFFF",
  },
  icon_emoji: {
    position: "absolute",
    bottom: 8,
    right: 8,
    "& >span >img": {
      width: 24,
      height: 24,
    },
  },
}));

export default function AddLesson() {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const listCategory = useAppSelector(selectCategoryList);

  const [isPostNow, setIsPostNow] = useState(false);
  const [disableDate, setDisableDate] = useState(false);
  const [draft, setDraft] = useState(false);
  const [errorVideo, setErrorVideo] = useState("");
  const [video, setVideo] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [filePPTX, setFilePPTX] = useState<any>("");
  const [idFilePTTX, setIdFilePPTX] = useState<any>("");
  const [openEmoji, setOpenEmoji] = useState<null | HTMLElement>(null);
  const [loading, setLoading] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);

  const schema = yup.object().shape({
    publishDate: yup.string().when("postNow", {
      is: false,
      then: yup.string().required(`${t("managerLesson.vuilongchonngaydang")}`),
    }),
    lessionCategoryId: yup
      .string()
      .required(`${t("managerLesson.vuilongchonchude")}`),
    lessionDescription: yup
      .string()
      .required(`${t("managerLesson.vuilongchonmota")}`),
    lessionTitle: yup
      .string()
      .required(`${t("managerLesson.vuilongnhaptenbaihoc")}`),
  });

  const schemaDraft = yup.object().shape({});

  const initialValues: CreateLesson = {
    postNow: false,
    isAll: true,
    publishDate: "",
    publishTime: "",
    hiddenDate: "",
    hiddenTime: "",
    lessionCategoryId: "",
    lessionDescription: "",
    lessionTitle: "",
    areaId: "",
    workTypeId: "",
    isDraft: "N",
    departmentId: "",
  };

  const { control, handleSubmit, setValue, getValues } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(draft ? schemaDraft : schema),
  });

  const handleOpenEmoji = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenEmoji(event.currentTarget);
  };

  const onEmojiClick = (event: any, emojiObject: any) => {
    setValue(
      "lessionDescription",
      getValues().lessionDescription + emojiObject.emoji
    );
  };

  useEffect(() => {
    dispatch(fetchCategoryList());
  }, [dispatch]);

  useEffect(() => {
    if (isPostNow) {
      setValue("publishDate", "");
      setDisableDate(true);
    } else {
      setDisableDate(false);
    }
  }, [isPostNow, setValue]);

  useEffect(() => {
    if (video !== "") {
      setErrorVideo("");
    }
  }, [video]);

  const token = localStorage.getItem(TOKEN);

  const handleSubmitForm = async (value: CreateLesson) => {
    if (video === "" && !draft && filePPTX === "") {
      setErrorVideo(`${t("managerLesson.vuilongchonvideobaihoc")}`);
      return;
    }
    let pubDate = "";
    let pubTime = "";
    if (value.postNow) {
      pubDate = moment(new Date()).format("YYYYMMDD");
      pubTime = moment(new Date()).format("HHmm");
    } else if (value.publishDate) {
      if (value.publishDate.includes("T")) {
        const [d, tStr] = value.publishDate.split("T");
        pubDate = d.split("-").join("");
        pubTime = tStr.split(":").join("");
      } else {
        pubDate = value.publishDate.split("-").join("");
        pubTime = value.publishTime ? value.publishTime.split(":").join("") : "";
      }
    }

    let hidDate = "";
    let hidTime = "";
    if (value.hiddenDate) {
      if (value.hiddenDate.includes("T")) {
        const [d, tStr] = value.hiddenDate.split("T");
        hidDate = d.split("-").join("");
        hidTime = tStr.split(":").join("");
      } else {
        hidDate = value.hiddenDate.split("-").join("");
        hidTime = value.hiddenTime ? value.hiddenTime.split(":").join("") : "";
      }
    }

    const newValue = {
      ...value,
      isDraft: draft ? "Y" : "N",
      isAll: "Y",
      publishDate: pubDate,
      publishTime: pubTime,
      hiddenDate: hidDate,
      hiddenTime: hidTime,
    };

    const formData = new FormData();
    formData.append("publishDate", newValue.publishDate);
    formData.append("publishTime", newValue.publishTime);
    formData.append("expiryDate", newValue.hiddenDate);
    formData.append("expiryTime", newValue.hiddenTime);
    formData.append("isAll", newValue.isAll);
    formData.append("isDraft", newValue.isDraft);
    formData.append("lessionCategoryId", newValue.lessionCategoryId);
    formData.append("lessionDescription", newValue.lessionDescription);
    formData.append("areaId", "");
    formData.append("workTypeId", "");
    formData.append("departmentId", "");

    fileVideo && formData.append("video", fileVideo);
    idFilePTTX.length > 0 &&
      formData.append("powerPointFileIDList", idFilePTTX);

    formData.append("lessionTitle", newValue.lessionTitle);
    setLoading(true);

    try {
      const res: AxiosResponse = await axios({
        method: "POST",
        url: `${BASE_URL}/lession/createLession`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
        onUploadProgress: (progressEvent) => {
          let percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent?.total
          );
          if (percent < 100) {
            setUploadPercentage(percent);
          }
        },
      });

      if (res.data.responseCode === "00") {
        setUploadPercentage(100);
        setTimeout(() => {
          setUploadPercentage(0);
        }, 1000);
        toast.success(`${t("managerLesson.taomoibaihocthanhcong")}`);
        navigate("/admin/manager-lesson");
        setLoading(false);
      } else {
        setUploadPercentage(0);
        toast.error(`${t("managerLesson.taobaihocthatbai")}`);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(`${t("managerLesson.taobaihocthatbai")}`);
    }
  };

  const handleChangeFile = async (acceptedFiles: any) => {
    if (
      acceptedFiles[0].type !== "video/mp4" &&
      !acceptedFiles[0].path.includes(".pptx")
    ) {
      setErrorVideo(`${t("managerLesson.tepkhongdungdinhdang")}`);
      return;
    }
    if (acceptedFiles[0].size > 500e7) {
      setErrorVideo(`${t("managerLesson.dungluongtoida")}`);
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(acceptedFiles[0]);
    const formData = new FormData();

    if (acceptedFiles[0].type === "video/mp4") {
      setFileVideo(acceptedFiles[0]);
      reader.onload = () => {
        setVideo(URL.createObjectURL(acceptedFiles[0]));
      };
    } else {
      try {
        acceptedFiles.forEach((acceptedFile: any) => {
          formData.append("attachments", acceptedFile);
        });

        const data = await managerFilesApi.uploadFiles(formData);
        const pptxFile = data?.body?.attachmentList?.[0];
        if (pptxFile) {
          setFilePPTX(pptxFile);
          setIdFilePPTX(pptxFile.id);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <Box className={classes.container}>
      {/* Loading Overlay */}
      {loading && (
        <Box className={classes.loadingOverlay}>
          <Box text-align="center" display="flex" flexDirection="column" alignItems="center">
            <CircularProgress style={{ color: "#FFFFFF", marginBottom: 16 }} />
            <Typography variant="h6" style={{ fontWeight: 800 }}>
              {t("managerLesson.dangtai")} {uploadPercentage}%
            </Typography>
          </Box>
        </Box>
      )}

      {/* Header Banner */}
      <Box className={classes.headerBanner}>
        <Button
          className={classes.btnBack}
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >
          Quay lại
        </Button>
        <Typography className={classes.bannerTitle}>
          TẠO BÀI HỌC MỚI
        </Typography>
      </Box>

      <form onSubmit={handleSubmit(handleSubmitForm)}>
        {/* Section 1: Lịch đăng & Lịch ẩn */}
        <Paper elevation={0} className={classes.sectionCard}>
          <Box className={classes.sectionHeader}>
            <CalendarTodayIcon style={{ color: "#4F46E5", fontSize: 22 }} />
            <Typography className={classes.sectionTitle}>
              CẤU HÌNH THỜI GIAN ĐĂNG & ẨN
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {/* Lịch đăng */}
            <Grid item xs={12} md={6}>
              <Typography className={classes.fieldLabel}>
                {t("managerLesson.lichdang")}
              </Typography>
              <InputField
                control={control}
                type="datetime-local"
                label=""
                name="publishDate"
                disabled={disableDate}
                size="small"
                borderRadius="12px"
              />
              <Box mt={1}>
                <CheckboxField
                  name="postNow"
                  label={t("managerLesson.dangngay")}
                  control={control}
                  handleChange={setIsPostNow}
                />
              </Box>
            </Grid>

            {/* Lịch ẩn */}
            <Grid item xs={12} md={6}>
              <Typography className={classes.fieldLabel}>
                {t("managerLesson.lichan")}
              </Typography>
              <InputField
                control={control}
                type="datetime-local"
                label=""
                name="hiddenDate"
                size="small"
                borderRadius="12px"
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Section 2: Thông tin nội dung bài học */}
        <Paper elevation={0} className={classes.sectionCard}>
          <Box className={classes.sectionHeader}>
            <DescriptionIcon style={{ color: "#0284C7", fontSize: 22 }} />
            <Typography className={classes.sectionTitle}>
              THÔNG TIN NỘI DUNG BÀI HỌC
            </Typography>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography className={classes.fieldLabel}>
                {t("managerLesson.chude")} *
              </Typography>
              <SelectField
                name="lessionCategoryId"
                label={t("managerLesson.chude")}
                options={listCategory}
                control={control}
                borderRadius="12px"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography className={classes.fieldLabel}>
                {t("managerLesson.tenbaihoc")} *
              </Typography>
              <InputField
                name="lessionTitle"
                label={t("managerLesson.tenbaihoc") + "..."}
                control={control}
                size="small"
                borderRadius="12px"
              />
            </Grid>

            <Grid item xs={12}>
              <Typography className={classes.fieldLabel}>
                {t("managerLesson.mota")} *
              </Typography>
              <Box position="relative" width="100%">
                <InputField
                  name="lessionDescription"
                  label={t("managerLesson.mota")}
                  control={control}
                  rows={3}
                  multiline
                  size="small"
                  borderRadius="12px"
                />
                <IconButton
                  onClick={handleOpenEmoji}
                  className={classes.icon_emoji}
                >
                  <img src={EMOJI} alt="EMOJI" />
                </IconButton>

                {openEmoji && (
                  <Menu
                    id="emoji-menu"
                    anchorEl={openEmoji}
                    keepMounted
                    open={Boolean(openEmoji)}
                    onClose={() => setOpenEmoji(null)}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                  >
                    <Picker
                      onEmojiClick={onEmojiClick}
                      disableAutoFocus={true}
                      skinTone={SKIN_TONE_MEDIUM_DARK}
                      groupNames={{ smileys_people: "PEOPLE" }}
                      native
                    />
                  </Menu>
                )}
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {/* Section 3: Tải lên Video / Bài giảng PowerPoint */}
        <Paper elevation={0} className={classes.sectionCard}>
          <Box className={classes.sectionHeader}>
            <VideocamIcon style={{ color: "#16A34A", fontSize: 22 }} />
            <Typography className={classes.sectionTitle}>
              TẢI LÊN VIDEO HOẶC SLIDE POWERPOINT (.MP4 / .PPTX)
            </Typography>
          </Box>

          <Dropzone onDrop={handleChangeFile}>
            {({ getRootProps, getInputProps }) => (
              <Box position="relative">
                {video === "" && filePPTX === "" && (
                  <Box {...getRootProps()} className={classes.dropzoneWrapper}>
                    <input
                      {...getInputProps()}
                      accept="video/* ,.pptx"
                      multiple={false}
                    />
                    <Box className={classes.dropzoneContent}>
                      <img
                        src={ICON_VIDEO}
                        alt="ICON_VIDEO"
                        className={classes.dropzoneIcon}
                      />
                      <Typography className={classes.dropzoneText}>
                        {t("managerLesson.themvideo")}
                      </Typography>
                      <Typography className={classes.dropzoneSubtext}>
                        {t("managerLesson.hoackeotha")}
                      </Typography>
                    </Box>
                  </Box>
                )}

                {/* Preview Video */}
                {video !== "" && (
                  <Box className={classes.videoPreviewWrapper}>
                    <IconButton
                      className={classes.closePreviewBtn}
                      onClick={() => setVideo("")}
                    >
                      <CloseIcon />
                    </IconButton>
                    <ReactPlayer
                      url={video}
                      controls={true}
                      width="100%"
                      height="400px"
                      config={{
                        file: { attributes: { controlsList: "nodownload" } },
                      }}
                      onContextMenu={(e: any) => e.preventDefault()}
                    />
                  </Box>
                )}

                {/* Preview PowerPoint */}
                {filePPTX !== "" && (
                  <Box className={classes.videoPreviewWrapper}>
                    <IconButton
                      className={classes.closePreviewBtn}
                      onClick={() => setFilePPTX("")}
                    >
                      <CloseIcon />
                    </IconButton>
                    <iframe
                      title="pptx-preview"
                      src={`https://view.officeapps.live.com/op/embed.aspx?src=${filePPTX.url}`}
                      width="100%"
                      height="500px"
                      style={{ border: "none" }}
                    />
                  </Box>
                )}
              </Box>
            )}
          </Dropzone>

          {errorVideo !== "" && (
            <Typography
              variant="subtitle2"
              color="secondary"
              style={{ marginTop: 12, fontWeight: 700 }}
            >
              {errorVideo}
            </Typography>
          )}
        </Paper>

        {/* Action Buttons Bar */}
        <Box className={classes.actionBar}>
          <Button
            type="submit"
            className={classes.btnDraft}
            startIcon={<SaveIcon />}
            onClick={() => setDraft(true)}
          >
            {t("managerLesson.luunhap")}
          </Button>

          <Button
            type="submit"
            className={classes.btnCreate}
            startIcon={<PublishIcon />}
            onClick={() => setDraft(false)}
          >
            {t("managerLesson.dangtin")}
          </Button>
        </Box>
      </form>
    </Box>
  );
}
